import React from 'react';
import CheckButton from '../../components/CheckButton';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';

type Answer = {
    name: string;
    value: string;
}

const PsychlngclCheckTraumatic: React.FC = () => {
    const answers: Answer[] = [];
    const goResult = (type: string) => {
        if ("cancel" === type) {
            if(window.confirm("정말 취소 하시겠습니까? '확인' 버튼을 누르면 심리검사목록 페이지로 이동합니다.")) {
                alert("취소되었습니다.");
                window.location.href="/psychlgclCheck/main";
            }
        } else if ("success" === type) {
            if (answers.length < 16) {
                alert("아직 응답하지 않은 문항이 있습니다.");
                return;
            } else {
                let total = 0;
                answers.map((answer) => (
                    total += parseInt(answer.value)
                ));
                let resultCode = '';
                if (0 <= total && total < 22) {
                    resultCode = "001";
                } else if (21 < total && total < 36) {
                    resultCode = "002";
                } else if (total > 35) {
                    resultCode = "003";
                }
                window.location.href=`/psychlgclCheck/traumatic/result/${resultCode}/${total}`;
            }
        }
    }

    const handleRadioChnage = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {value, name} = e.target;
        if (answers.length > 0) {
            // name이 존재하면
            if (answers.findIndex((element) => element.name === name) !== -1) {
                answers[answers.findIndex((element) => element.name === name)].value = value;
            } else {
                answers.push({name: name, value: value});    
            }
        } else {
            answers.push({name: name, value: value});
        }
    }

    return (
        <div id="warp">
            <Header />
            <section id="containers">
                <div className='therapy'>
                    <Lnb />
                    <div id="contents" className="contents">
                        <h2>무료심리검사</h2>
                        <Location locations={[
                            {title: "토닥토닥마음케어", url: "/column/columnList"}
                            , {title: "무료심리검사", url: "/psychlgclCheck/main"}]} 
                            menuName='불안 자가진단'
                        />
                        <div className="mobileface testing">
					        <div className="testWrap traumatic">
                                <h3 className="f18 black">외상 후 스트레스</h3>
                                <div className="visualBox mt23">
                                    <p className="black lh30"> 
                                        아래에는 충격적인 사건을 경험한 이후에 사람들에게서 나타날 수 있는 어려움들입니다.<br /><strong className="f16">지난 한 달 동안에 나타난 것에 체크해 주십시오.</strong>
                                    </p>
                                </div>
                                <h4 className="f14 green mt30">외상 후 스트레스 진행 (17문항)</h4>
                                <fieldset>
                                    <ul className="etc_list col4">
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">1. 그 일에 대해 생각하고 싶지 않을 때 불쑥 생각나거나 머릿속에 그려진다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq1" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq1" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq1" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq1" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">2. 그 일과 관련된 악몽을 꾼다. </dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq2" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq2" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq2" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq2" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">3. 그 일이 마치 재현되듯 생생하게 느껴지고 그 때 당시처럼 행동하게 된다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq3" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq3" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq3" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq3" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">4. 그 일을 떠올리면 괴로운 감정이 든다(예: 두렵다, 분노가 치밀어 오른다, 슬프다, 죄책감이 느껴진다 등)</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq4" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq4" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq4" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq4" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">5. 그 일을 떠올리면 신체적 반응이 느껴진다(진땀이 난다, 심장이 뛴다 등)</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq5" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq5" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq5" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq5" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">6. 그 일에 대해서는 생각하거나, 말하지 않으려고 하고, 당시의 느낌조차 떠올리지 않으려고 애를 쓴다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq6" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq6" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq6" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq6" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">7. 그 일을 생각나게 하는 활동이나 사람들, 장소들을 가급적 피하려 한다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq7" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq7" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq7" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq7" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">8. 그 일과 관련된 중요한 기억의 한 부분이 도무지 생각나지 않는다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq8" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq8" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq8" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq8" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">9. 지금 내 생활에서 중요한 것들에 대해 흥미가 떨어지거나 의욕이 낮아졌다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq9" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq9" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq9" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq9" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">10. 주위 사람들과 멀어지거나 단절된 느낌이다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq10" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq10" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq10" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq10" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">11. 정서가 메마른 것처럼 무감각하다(예: 눈물이 나지 않는다, 애정어린 기분을 느낄 수 없다 등)</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq11" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq11" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq11" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq11" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">12. 내 미래의 계획이 뜻대로 이루어질 것 같지 않고 희망이 없이 느껴진다(예: 제대로 된 직장이나 가족을 가지지 못할 것이다, 오래 살지 못할 것이다 등)</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq12" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq12" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq12" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq12" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">13. 잠이 잘 오지 않고 자더라도 자주 깬다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq13" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq13" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq13" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq13" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">14. 짜증이 잘 나고 신경질을 종종 부린다.</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq14" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq14" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq14" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq14" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">15. 집중하기 어렵다(예: 대화중에 다른 생각을 한다, TV 드라마를 보다가 줄거리를 놓친다, 방금 읽은 내용을 기억하지 못한다 등)</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq15" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq15" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq15" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq15" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">16. 지나친 긴장 상태에 있다(예: 주위에 누가 있는지 자꾸 확인한다, 문쪽으로 등을 돌리고 있으면 불안하다 등)</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq16" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq16" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq16" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq16" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                        <li>
                                            <dl>
                                                <dt className="mt5 lh18">17. 작은 일에도 쉽게 놀란다(예: 누가 뒤에서 걸어오는 것을 느낄 때 등)</dt>
                                                <dd className="mt15 space">
                                                    <label><input type="radio" name="tq17" value="0" onChange={handleRadioChnage} /> 전혀없음</label>
                                                    <label><input type="radio" name="tq17" value="1" onChange={handleRadioChnage} /> 1주일에 1번</label>
                                                    <label><input type="radio" name="tq17" value="2" onChange={handleRadioChnage} /> 1주일 2~4번</label>
                                                    <label><input type="radio" name="tq17" value="3" onChange={handleRadioChnage} /> 1주일 5번 이상</label>
                                                </dd>
                                            </dl>
                                        </li>
                                    </ul>
							    </fieldset>
                                <CheckButton goResult={goResult} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default PsychlngclCheckTraumatic;